import React from 'react'
import { SupportButton } from '@shared/ui/support-button'
import s from './style.module.scss'

export const Maintenance = () => {
	return (
		<section className={s.wrapper}>
			<div className={s.glowTop} aria-hidden="true" />
			<div className={s.glowBottom} aria-hidden="true" />

			<div className={s.card}>
				<div className={s.badge}>Техническое обслуживание</div>

				<div className={s.visual} aria-hidden="true">
					<div className={s.vinyl}>
						<div className={s.vinylCenter} />
					</div>
					<div className={s.wave} />
					<span className={s.noteLeft}>♪</span>
					<span className={s.noteRight}>♫</span>
				</div>

				<div className={s.content}>
					<h1>Созвучно на техническом обслуживании</h1>
					<p>Мы улучшаем платформу и скоро вернёмся</p>
					<SupportButton
						label="Написать в поддержку"
						shape="pill"
						className={s.supportWrapper}
						buttonClassName={s.supportButton}
					/>
				</div>
			</div>
		</section>
	)
}
